import { render, staticRenderFns } from "./select-category.vue?vue&type=template&id=8b7f1cba"
import script from "./select-category.vue?vue&type=script&lang=js"
export * from "./select-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports